module.exports = __webpack_public_path__ + "static/img/图片19.91c92179.png";